// pages/RotaBuilderPage.tsx
import React from 'react';
import {
  Container,
  Typography,
  Breadcrumbs,
  Link as MuiLink,
  Box
} from '@mui/material';
import { Link } from 'react-router-dom';
import RotaBuilder from '../components/RotaBuilder/RotaBuilder';

const RotaBuilderPage: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Breadcrumbs aria-label="breadcrumb" sx={{ my: 2 }}>
        <MuiLink component={Link} to="/" color="inherit">
          Home
        </MuiLink>
        <Typography color="text.primary">Rota</Typography>
      </Breadcrumbs>

<Box sx={{ mb: 4 }}>
  <Typography variant="h3" component="h1" gutterBottom>
    Staff Rota
  </Typography>
  <Typography variant="body1" color="text.secondary">
    Create and manage staff schedules with ease. <br />
    Fill entire months in seconds, then fine-tune individual days. <br />
    Please ensure to have at least two months scheduled in advance at all times.
  </Typography>
</Box>

      <RotaBuilder />
    </Container>
  );
};

export default RotaBuilderPage; 